/*
 * @Descripttion:材料仓库
 * @Author: lc
 * @Date: 2021-10-25 08:33:06
 * @LastEditors: lc
 * @LastEditTime: 2021-10-25 08:35:57
 */
import axios from '.././http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来


// 接口请求地址
const api = '/c-api/';

const data = {
    // 列表
    list(params) {
        return axios.get(api + 'data/list', { params: params })
    },
    //添加
    create(params) {
        return axios.post(api + 'data/create', qs.stringify(params))
    },
    //获取编辑信息
    detail(params) {
        return axios.get(api + 'data/detail', { params: params })
    },
    //修改
    edit(params) {
        return axios.post(api + 'data/edit', qs.stringify(params))
    },
    //删除
    remove(params) {
        return axios.post(api + 'data/remove', qs.stringify(params))
    },
}


// 导出接口
export default data
